import AccordionBlock from './AccordionBlock';
import AccordionBlocks from './AccordionBlocks';

export { AccordionBlocks, AccordionBlock };
